import React, { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import axios from 'config/axios';
import { useAppDispatch } from 'hooks/useStore';
import Helmet from 'components/Helmet';
import { initializeCart } from 'store/cart';
import { setAlert } from 'store/error';
import CheckoutForm from './CheckoutForm';

const stripePromise = loadStripe(process.env.STRIPE_PUBLISHABLE_KEY);

function Checkout() {
    const [total, setTotal] = useState(0);
    const [paymentId, setPaymentId] = useState('');
    const [clientSecret, setClientSecret] = useState('');

    const dispatch = useAppDispatch();

    useEffect(() => {
        axios.get('payments/checkout/')
            .then(res => {
                // console.log(res.data);
                dispatch(initializeCart({
                    bundles: res.data?.bundleItems,
                    courses: res.data?.courseItems,
                    tests: res.data?.testItems
                }));
                setTotal(res.data?.total);
                setPaymentId(res.data?.paymentId);
                setClientSecret(res.data?.clientSecret);

                if (res.data?.total > 0) {
                    ReactGA.event('begin_checkout', {
                        currency: 'USD',
                        value: res.data?.total,
                        items: [
                            ...res.data?.bundleItems.filter(bundle => (
                                !bundle.numRequired
                            )).reduce((bundleItemList, bundle) => (
                                [
                                    ...bundleItemList,
                                    ...bundle.courses.map(course => ({
                                        item_id: course.urlSlug,
                                        item_name: course.name
                                    })),
                                    ...bundle.tests.map(test => ({
                                        item_id: test.testId,
                                        item_name: test.name
                                    }))
                                ]
                            ), []),
                            ...res.data?.courseItems.map(course => ({
                                item_id: course.urlSlug,
                                item_name: course.name
                            })),
                            ...res.data?.testItems.map(test => ({
                                item_id: test.testId,
                                item_name: test.name
                            }))
                        ]
                    });
                }
            })
            .catch(error => {
                // console.log(error);
                dispatch(setAlert(error));
            });
    }, []);

    if (!clientSecret) return <></>;

    return (
        <Elements stripe={stripePromise} options={{
            clientSecret,
            fonts: [
                {
                    cssSrc: 'https://fonts.googleapis.com/css2?family=Source+Sans+Pro:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700;1,900&display=swap'
                }
            ],
            appearance: {
                theme: 'stripe',
                labels: 'floating',
                variables: {
                    colorPrimary: '#0575A2', 
                    colorBackground: '#ffffff',
                    colorText: '#000000',
                    colorDanger: '#ee4b2b',
                    colorSuccess: '#27ae60',
                    colorWarning: '#f2994a',
                    fontFamily: 'Source Sans Pro, system-ui, sans-serif',
                    spacingUnit: '4px',
                    spacingTab: '20px',
                    borderRadius: '5px',
                    fontSizeBase: '18px',
                },
            }
        }}>
            <Helmet
                title='Checkout - The SAT Crash Course'
            />
            <CheckoutForm
                total={total}
                paymentId={paymentId}
                updateTotal={setTotal}
            />
        </Elements>
    )
}

export default Checkout;